import { render, staticRenderFns } from "./SavedSearches.vue?vue&type=template&id=82763700&scoped=true&"
import script from "./SavedSearches.vue?vue&type=script&lang=js&"
export * from "./SavedSearches.vue?vue&type=script&lang=js&"
import style0 from "./SavedSearches.vue?vue&type=style&index=0&id=82763700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82763700",
  null
  
)

export default component.exports